import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import CreateRetailerForm from '../../auth/CreateRetailerForm';
import styled from 'styled-components';
import Breakpoints from '../../../lib/Breakpoints'
import Cookies from 'js-cookie'
import jwtDecode from 'jwt-decode'

const Wrapper = styled.div`
  width: 380px;
  @media (max-width: ${Breakpoints.phone}) {
    padding: 5px;
    width: 95%;
   }
`;

const CreateRetailer = ({ hydrateCurrentUser, manuallySetJWTFromCookie, history }) => {
  useEffect(() => {
    const jwt = Cookies.get('userSessionIdentifier')
    if (jwt) {
      manuallySetJWTFromCookie(jwt)
      try {
        const user = jwtDecode(jwt)
        if (user) {
          hydrateCurrentUser(user)
        }
      }
      catch(err) {
        history.push('/auth')
      }
    } else {
      history.push('/auth')
    }
  }, [])
  return (
    <>
      <Wrapper>
        <CreateRetailerForm onrampType={'test'}/>
      </Wrapper>
    </>
  )
}

CreateRetailer.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  hydrateCurrentUser: PropTypes.func,
  manuallySetJWTFromCookie: PropTypes.func,
}

export default withRouter(CreateRetailer)